import { downgradeComponent } from '@angular/upgrade/static';
import { ScheduleListContainerComponent } from '@mode/shared/schedules/feature-schedules-list';
import * as angular from 'angular';

export const DowngradedSharedFeatureScheduleListModule = angular
  .module('downgraded-shared-feature-schedule-list', [])
  .directive('modeScheduleListContainer', downgradeComponent({ component: ScheduleListContainerComponent })).name;
